export default __webpack_public_path__ + "media/zurb/img/services/process/designer-img-916553338287bc48c2b5d403d758ac7e.png";